module.exports = __webpack_public_path__ + "img/MG_4570-scaled.8ac37074.jpg";